import { c as _c } from "react/compiler-runtime";
import PopupComponent, { PopupContext, PopupType } from '../popup/popup.component';
import { ReactElement, useId, useState } from 'react';
import ImageComponent from '../image-component/image.component';
import { ProductReviewPhoto } from '@spa/generated/graphql/graphql';
import styles from './bazaarvoice-review-photo.module.scss';
import useHasOpenedOnce from '@spa/lib/react/hooks/useHasOpenedOnce';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
type BazaarvoiceReviewPhotoProps = {
  readonly description: string;
  readonly photo: ProductReviewPhoto;
};
export const BazaarvoiceReviewPhoto = t0 => {
  const $ = _c(18);
  const {
    description,
    photo
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-section");
  const [showPopup, setShowPopup] = useState(false);
  const hasOpened = useHasOpenedOnce(showPopup);
  const titleId = useId();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowPopup(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== description || $[2] !== formatMessage) {
    t2 = formatMessage("enlargeCustomerPhoto", {
      description
    });
    $[1] = description;
    $[2] = formatMessage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== photo.normalUrl) {
    t3 = <ImageComponent src={photo.normalUrl} alt="" width={96} height={96} className={styles["bazaarvoice-review-photo__image"]} />;
    $[4] = photo.normalUrl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <button type="button" className={styles["bazaarvoice-review-photo__button"]} onClick={t1} aria-label={t2} aria-haspopup="dialog">{t3}</button>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== description || $[10] !== hasOpened || $[11] !== photo.largeUrl || $[12] !== showPopup || $[13] !== titleId) {
    t5 = hasOpened && <PopupComponent isOpen={showPopup} onClosed={() => setShowPopup(false)} popupType={PopupType.FULLSCREEN_MOBILE} popupContext={PopupContext.WITHOUT_TITLE} ariaLabelledBy={titleId} focusDialogOnOpen={true}><span id={titleId} className="sr-only">{description}</span><div className={styles["bazaarvoice-review-photo__full-size-wrapper"]}><ImageComponent src={photo.largeUrl} alt={description} width={700} height={700} className={styles["bazaarvoice-review-photo__full-size-image"]} /></div></PopupComponent>;
    $[9] = description;
    $[10] = hasOpened;
    $[11] = photo.largeUrl;
    $[12] = showPopup;
    $[13] = titleId;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className={styles["bazaarvoice-review-photo__tile"]}>{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};